import { Locale } from '@wyz/types';
import { Button, Dropdown, Flex, Nav } from '@wyz/ui';
import {
  LocaleUtils,
  polyfillDatetimeFormat,
  polyfillDisplayNames,
  polyfillNumberFormat,
  polyfillRelativetimeformat,
} from '@wyz/utils';
import { useNavigate } from 'react-router';
import { useManageUsers } from '~/common/api';
import { AutomakerLogoHolder, CountryFlag } from '~/common/components';
import { useApplicationContext, useLocale } from '~/common/context';
import { log } from '~/common/helpers';

// eslint-disable-next-line @wyz/module/no-relative-import
import ProfileDropdown from './profile-dropdown';

const TopNavRightSideNavItem = () => {
  const { locale, country, languages } = useLocale();
  const applicationContext = useApplicationContext();
  const navigate = useNavigate();
  const manageUsers = useManageUsers({
    updateLocale: { enabled: true },
  });
  const loadLocaleApis = async (newLocale: Locale) => {
    await polyfillDatetimeFormat(newLocale);
    await polyfillRelativetimeformat(newLocale);
    await polyfillDisplayNames(newLocale);
    await polyfillNumberFormat(newLocale);
  };

  const handleOnUpdateLocale = (locale: string) => {
    try {
      void loadLocaleApis(locale);
      // eslint-disable-next-line no-empty
    } catch {}
    manageUsers.updateLocale.mutate(
      { id: String(applicationContext.auth.userId), locale },
      {
        onSuccess: () => {
          applicationContext.auth
            .signinSilent()
            .then(() => {
              window.location.reload();
            })
            .catch((error: Error) => {
              log(error);
              void navigate('/500');
            });
        },
      },
    );
  };

  return (
    <Nav
      navbar
      className='navbar-nav-icons ms-auto flex-row align-items-center'
      as='ul'
    >
      <AutomakerLogoHolder />
      <Dropdown.Container>
        <Dropdown.Toggle bsPrefix='toggle' as='div' id='select-locale-toggler'>
          <Button
            id='select-locale'
            onClick={() => {}}
            variant='tertiary-blue'
            size='xs'
          >
            <Flex className='space-x-2' alignItems='center'>
              <CountryFlag countryCode={country} width={20} />
              <span className='text-nowrap'>
                {LocaleUtils.getHumanReadableLabel({
                  userLocale: locale,
                  locale: locale,
                  fallback: locale,
                })}
              </span>
            </Flex>
          </Button>
        </Dropdown.Toggle>

        <Dropdown.Menu className='dropdown-caret dropdown-menu-card dropdown-menu-end'>
          {languages.byIndex.map((language) => (
            <Dropdown.Item
              key={language.isoCode}
              as='button'
              type='button'
              className='fs-xs space-x-2'
              onClick={() => {
                handleOnUpdateLocale(language.isoCode);
              }}
              id={language.isoCode}
            >
              <CountryFlag
                countryCode={language.isoCode.split('-').at(1) ?? ''}
                width={20}
              />
              <span>{language.humanName}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown.Container>

      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
